import { render, staticRenderFns } from "./AddQuiz.vue?vue&type=template&id=5b9b154c&scoped=true&"
import script from "./AddQuiz.vue?vue&type=script&lang=js&"
export * from "./AddQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b154c",
  null
  
)

export default component.exports